export default {
	readings: {
		general: {
			measure: "Medida",
			latest: "Mais recentes",
			history_graph: "Gráfico de histórico",
			history_map: "Mapa de histórico",
			alert_parameters: "Parâmetros de alertas",
			alert_reports: "Relatório de alertas",
			zone_list: "Lista de zonas",
			no_readings: "Nenhuma leitura encontrada",
			no_parameters: "Nenhum parâmetro encontrado",
			no_zones: "Nenhuma zona encontrada",
			no_alerts: "Nenhum alerta encontrado",
			no_location: "Nenhuma localização encontrada",
		},
		hearthrate: {
			name: "Frequência cardíaca",
			unit: "bpm",
			html: "bpm"
		},
		bloodpressure: {
			name: "Pressão arterial",
			unit: "mmHg",
			html: "mmHg"
		},
		temperature: {
			name: "Temperatura",
			unit: "°C",
			html: "°C"
		},
		bloodsaturation: {
			name: "Saturação Sanguínea",
			unit: "% spO2",
			html: "% spO<sub>2</sub>"
		},
		position: {
			name: "Posição",
			unit: "lat lng",
			html: "lat lng"
		},
		calories: {
			name: "Calorias",
			unit: "kcal",
			html: "kcal"
		},
		pedometer: {
			name: "Pedómetro",
			unit: "passos",
			html: "passos"
		},
		falls: {
			name: "Quedas",
			unit: "",
			html: "",
			fall_detected: "Queda detectada"
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n/readings/readings_pt.js